"use client";
import { Typography } from "@components/typography";
import CheckIcon from "@icons/check";
import clsx from "clsx";
import { DropdownMenu } from "radix-ui";
import React from "react";
import type { MenuCheckboxItemProps } from "./interface";
import css from "./styles.module.css";

/** @ignore */
export const MenuCheckboxItem = React.forwardRef<HTMLDivElement, MenuCheckboxItemProps>(
  ({ label, StartIcon, checked, trailingSlot, disabled, onSelect, supportingText, ...props }, ref) => {
    return (
      <DropdownMenu.CheckboxItem
        {...props}
        data-quipu="MenuCheckboxItem"
        className={css.root}
        ref={ref}
        checked={checked}
        disabled={disabled}
        onSelect={(e) => {
          e.preventDefault();
          onSelect?.(e);
        }}
      >
        <DropdownMenu.ItemIndicator className={clsx(css.checkIcon, disabled && css.disabledCheckIcon)}>
          <CheckIcon />
        </DropdownMenu.ItemIndicator>
        {StartIcon && (
          <span className={css.startIcon}>
            <StartIcon active={checked} />
          </span>
        )}
        <span className={css.label}>
          <span>{label}</span>
          {supportingText && (
            <Typography component="span" variant="labelSmSubtle" color="subtle">
              {supportingText}
            </Typography>
          )}
        </span>
        {trailingSlot && <span className={css.trailingSlot}>{trailingSlot}</span>}
      </DropdownMenu.CheckboxItem>
    );
  },
);

MenuCheckboxItem.displayName = "MenuCheckboxItem";
